export const DAYS_OF_THE_WEEK = [
  "Su",
  "Mo",
  "Tu",
  "We",
  "Th",
  "Fr",
  "Sa"
] as const;
